var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomersinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.122 26.015c-.611-1.224-2.7-1.992-5.591-3.055l-.895-.333a.21.21 0 01-.136-.192v-1.769a.209.209 0 01.07-.155 3.543 3.543 0 001.166-2.306.207.207 0 01.059-.128c.189-.212.317-.471.37-.75a1.907 1.907 0 00-.265-1.609.211.211 0 01-.032-.21c.548-1.1.793-2.326.708-3.552-.277-1.382-2.224-1.916-3.808-1.956-1.317-.029-2.945.259-3.507 1.136a.208.208 0 01-.143.095 1.539 1.539 0 00-1.048.602c-.865 1.167.117 3.75.09 3.667a.21.21 0 01-.04.196 1.892 1.892 0 00-.287 1.63c.054.278.182.537.371.75.034.034.055.079.06.127a3.544 3.544 0 001.166 2.306.21.21 0 01.07.157v1.769a.209.209 0 01-.136.196l-.896.333c-2.891 1.062-4.98 1.833-5.59 3.055A8.81 8.81 0 0010 29.583a.417.417 0 00.417.417h19.166a.417.417 0 00.417-.417 8.812 8.812 0 00-.878-3.567z",
    fill: "#0F0449"
  })));
}

export default SvgCustomersinline;